import api from "../api";

const getUser= async () => {

    try {

      const response = await api.get(process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT + "/app/auth/me?populate=storeAppUsers&populate=storeAppUsers.store&populate=appUserCoupons&populate=appUserCoupons.store");

      return response.data;
    }
     catch (error) {
      console.error('There was a problem with the axios operation:', error);
      throw error;
    }
  
}

export default getUser;
